export const environment = {
  production: false,
  apiUrl: 'https://concurso-api-teste.zoomeduca.com.br/api',
  version: '1.0.0',
  appName: 'Zoom Educa - Portal de Concursos'
};

// # Build para teste
// ng build --configuration=test

// # Servir em modo teste
// ng serve --configuration=test